import angular from 'angular';
import { routing } from './transition.offer.wizard.config';
import TransitionOfferWizardComponent from './transition.offer.wizard.component';
export default angular.module('index.customercare.customer.orders.transitionoffer', []).component('transitionOffer', TransitionOfferWizardComponent).config(routing).name;